import React from "react";
import "./App.scss";

import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Redirect, Route } from "react-router";

import Navbar from "./Containers/Navbar";
import Home from "./Views/Home";
import Cv from "./Views/Cv";
import Projects from "./Views/Projects";
import ProjectDetails from "./Components/ProjectDetails";
import ErrorBoundary from "./Containers/ErrorBoundary";
import { NotFound } from "./Views/NotFound";

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <div className="App">
          <Navbar></Navbar>
          <Switch>
            <Redirect exact from="/" to="/home" />
            <Route exact path="/home" component={Home} />
            <Route exact path="/cv" component={Cv} />
            <Route exact path="/projects" component={Projects} />
            <Route path="/projects/:id" component={ProjectDetails} />
            <Route path="/" component={NotFound} />
          </Switch>
        </div>
      </ErrorBoundary>
    </Router>
  );
}
export default App;
